import Vue from "vue"
import {updateField} from "vuex-map-fields"
import {getField} from "vuex-map-fields"

export const actions = {
    openPanel({state}) {
        if (state.panel_open) return Vue.noty.error('Note is already open. Please close it to open a new one.')
        state.panel_open = true
    },
    closePanel({state}) {
        state.panel_open = false
    },
}

export const getters = {
    getField,
}

export const mutations = {
    updateField,
}

export const state = () => ({
   panel_open: false
})
